import { useCampaignPlannerRoute } from '@/dashboards/CampaignPlanner/providers';
import { useRouteUrl } from '@/hooks';

export const useCampaignPlannerUrl = () => {
    const { route } = useCampaignPlannerRoute();

    return useRouteUrl(route);
};
